import { createFileRoute } from "@tanstack/react-router";
import { TicketCreateForm } from "@/components/support/TicketCreateForm";

export const Route = createFileRoute("/_public/help/ticket")({
	component: TicketCreatePage,
});

function TicketCreatePage() {
	return <TicketCreateForm />;
}
